module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Medium.fff9ad59.woff2";